import {Typography} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';

const {confirmationPage} = translations['pt-br'].privateFlow.bookingFlow;

export const AppointmentDocumentAlert = () => {
	return (
		<AlertInfo.Root severity="info">
			<AlertInfo.Description>
				<Typography variant="body2">{confirmationPage.appointmentAlert}</Typography>
			</AlertInfo.Description>
		</AlertInfo.Root>
	);
};
